<template>
  <div
    :class="`modal ${toggle ? 'active' : ''}`"
    :style="`--modal-width:${width / 10}rem`"
  >
    <div class="modal-background" @click="closeHandler"></div>
    <div class="modal-container">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-header__title">
            <slot name="header">
              {{ title }}
            </slot>
          </div>
          <div
            v-if="topCloseVisible"
            class="modal-header__close"
            @click="closeIconHandler"
          >
            <i class="fas fa-times active" />
          </div>
        </div>

        <div class="modal-body">
          <slot></slot>
        </div>

        <div class="modal-footer clear-both">
          <slot name="footer">
            <pb-float float="right">
              <pb-button ghost @click="closeIconHandler">취소</pb-button>
              <pb-button ghost @click="confirmHandler">확인</pb-button>
            </pb-float>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PbModal",
  props: {
    value: Boolean,
    title: String,
    beforeClose: Function,
    onClose: Function,
    topCloseVisible: {
      type: Boolean,
      default: () => true,
    },
    width: {
      type: String,
      default: () => "400",
    },
  },
  computed: {
    toggle: {
      set(newValue) {
        if (this.onClose && typeof this.onClose === "function") {
          this.onClose();
        }

        this.$emit("input", newValue);
      },
      get() {
        return this.value;
      },
    },
  },
  methods: {
    closeIconHandler() {
      this.toggle = false;
    },

    closeHandler() {
      if (this.beforeClose && typeof this.beforeClose === "function") {
        setTimeout(() => {
          this.beforeClose();
        }, 250);
      }

      this.toggle = false;
    },

    confirmHandler() {
      this.$emit("confirm");
    },
  },
};
</script>
<style lang="scss">
@import "~styles/size";

.modal-background {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1101;
}

.modal {
  position: fixed;
  z-index: 1100;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: all 0.35s;

  display: flex;
  justify-content: center;
  align-items: center;
  visibility: hidden;
  opacity: 0;

  &.active {
    opacity: 1;
    visibility: visible;
  }

  &-container {
    position: absolute;
    top: 7vh;
    padding-bottom: 10vh;
    max-width: 1240px;
    z-index: 1102;
    border-radius: 3px;
    margin: 0 auto;
    width: var(--modal-width);
    // margin-left: auto;
    // margin-right: auto;

    @media (max-width: $min_layout) {
      width: calc(100vw - 80px);
    }
  }

  &-content {
    background-color: #ffffff;
    border-radius: 5px;
  }

  &-body {
    font-size: 1.4rem;
    padding-left: 24px;
    padding-right: 24px;
  }

  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 0;

    &__title {
      font-size: 1.8rem;
      font-weight: 600;
      padding-left: 24px;
    }

    &__close {
      font-size: 1.6rem;
      margin-right: 24px;
      text-align: center;
      cursor: pointer;
    }
  }

  &-footer {
    padding: 10px 24px 12px 24px;
  }
}
</style>
